import axios from 'axios';

export default {

    getCommercialsList(userId, type = null) {
        let params = '';
        if(type) {
            params = params + '?type='+type;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/commercials/' + userId + '/list' +  params);
    },

    getCommercialsListing() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/commercials');
    },

    getConnections(userId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/commercials/' + userId + '/connections');
    },
}
